<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3533_138391)">
<path d="M16.4795 21H3.47949V3H9.65949C10.5458 3.00066 11.4067 3.29565 12.1072 3.83864C12.8076 4.38163 13.3079 5.14187 13.5295 6C14.3734 6.22956 15.1188 6.72937 15.6516 7.42289C16.1844 8.11642 16.4752 8.96546 16.4795 9.84V21Z" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
<path d="M14.2795 6.26994L14.7195 4.18994L17.2395 4.71994L19.3695 5.16994C20.0301 5.30903 20.6268 5.66133 21.0677 6.17266C21.5085 6.68399 21.7692 7.32601 21.8095 7.99994C22.3173 8.25881 22.7427 8.65436 23.0377 9.142C23.3328 9.62965 23.4858 10.19 23.4795 10.7599C23.4809 10.9785 23.4574 11.1966 23.4095 11.4099L21.6295 19.8099L19.4795 19.3499" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
<path d="M6.47949 17H13.4795" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
<path d="M6.47949 13H13.4795" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
</g>
<defs>
<clipPath id="clip0_3533_138391">
<rect width="24" height="24" fill="white" transform="translate(0.479492)"/>
</clipPath>
</defs>
</svg>
